import { reactive } from 'vue'
import { locationOptions } from '@/data/getActivityFilterOptions'

export class CheckBox {
    constructor(queryItems) {
        this.checkAll = reactive([false, false, false, false, false])
        this.isIndeterminate = reactive([false, false, false, false, false])
        this.queryItems = queryItems
        this.locationOptions = locationOptions
    }
    handleCheckAllChange(index) {
        if (this.checkAll[index])
            this.queryItems[locationOptions[index].model] =
                this.locationOptions[index].options
        else this.queryItems[locationOptions[index].model] = []
        this.isIndeterminate[index] = false
    }
    handleCheckChange(index) {
        const currLen = this.queryItems[locationOptions[index].model].length
        const totLen = this.locationOptions[index].options.length
        this.isIndeterminate[index] = currLen > 0 && currLen < totLen
        this.checkAll[index] = currLen === totLen
        return
    }
    initCheck() {
        for (let i = 0; i < this.checkAll.length; i++) {
            let keys = Object.keys(this.locationOptions)
            this.handleCheckChange(i, keys[i])
        }
    }
}
